import { AllFormsDataCollectionDocument, DeleteFormDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import DeleteModal from 'modules/trainings/components/Revamp/TrainingsDetail/Forms/AllFormsDatatable/DeleteModal'

type Data = {
  trainingId: string
  formId: string
}

export const DeleteSurveyActivity: ActivityComponent<Data> = ({ formId }) => {
  const { open, closeActivity } = useActivity()
  const [deleteForm] = useMutation(DeleteFormDocument, {
    extractorFn: (data) => data.formsMutations.deleteFormsForm,
  })

  if (!open) return null

  const onSubmit = async () => {
    const response = await deleteForm({
      variables: { id: formId },
      refetchQueries: [AllFormsDataCollectionDocument],
    })
    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.trainings_revamp.delete_event_modal.forms.error_delete'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.trainings_revamp.delete_event_modal.forms.success_delete'),
      })
      closeActivity()
    }
  }

  return (
    <DeleteModal
      title={i18n.t('trainings.forms.delete_survey.title')}
      description={i18n.t('trainings.forms.delete_survey.description')}
      onSubmit={onSubmit}
      onClose={closeActivity}
    />
  )
}
